module.exports = "/_next/static/images/stats-monotone-f411e8af2820b4fcf5d490ffa3dae1f1.svg";